<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="block">
          <h2>我的信息</h2>
          <div class="table">
            <div class="info_row">
              <span>用户名</span>
              <span>{{accountInfo.userInfo.fullName}}</span>
            </div>
            <div class="info_row">
              <span>邮箱</span>
              <span>{{accountInfo.email}}</span>
            </div>
            <div class="info_row">
              <span>手机号</span>
              <span>{{accountInfo.mobile}}</span>
            </div>
            <div class="info_row">
              <span>身份证</span>
              <span>{{accountInfo.userInfo.idNumber}}</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="block">
          <h2>账号信息</h2>
          <div class="table">
            <div class="info_row">
              <span>状态</span>
              <span>{{accountInfo.status===1?'启用':"未启用"}}</span>
            </div>
            <div class="info_row">
              <span>登录次数</span>
              <span>{{accountInfo.loginCount}}</span>
            </div>
            <div class="info_row">
              <span>最后登录时间</span>
              <span>18692117761</span>
            </div>
            <div class="info_row">
              <span>最后登录IP</span>
              <span>{{accountInfo.lastLoginIp}}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-button @click="resetPwd" type="primary" class="reset_pwd">重设密码</el-button>
    <!-- 重设密码弹窗 -->
    <CModel ref="resetModel" @confirm="submitBtn">
      <el-form ref="resetForm" :model="user" label-width="130px">
        <div class="form-items">
          <!-- <el-row class="form-item">
            <el-col>
              <el-form-item prop="email" label="邮箱号或用户名:" required :rules="{type:'email'}">
                <div class="form-line">
                  <el-input placeholder="邮箱" v-model="user.email"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row class="form-item">
            <el-col>
              <el-form-item prop="emailCaptcha" label="验证码:" required>
                <div class="form-line">
                  <el-row :gutter="0">
                    <el-col :span="16" :offset="0">
                      <el-input placeholder="验证码" v-model="user.emailCaptcha"></el-input>
                    </el-col>
                    <el-col :span="5" :offset="1">
                      <CVerificationCode :send-type="5" :value="user.email" />
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row class="form-item">
            <el-col>
              <el-form-item prop="oldPwd" label="旧密码:" required>
                <div class="form-line">
                  <el-input type="password" placeholder="旧密码" v-model="user.oldPwd"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="form-item">
            <el-col>
              <el-form-item prop="newPwd" label="新密码:" required>
                <div class="form-line">
                  <el-input type="password" placeholder="新密码" v-model="user.newPwd"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="form-item">
            <el-col>
              <el-form-item prop="repeatNewPass" label="确认新密码:" required>
                <div class="form-line">
                  <el-input type="password" placeholder="确认新密码" v-model="user.repeatNewPass"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="form-item">
            <el-col>
              <el-form-item>
                <!-- <el-checkbox class="checkbox">记住账号</el-checkbox> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </CModel>
  </div>
</template>

<script>
import { userRes } from "@/api";
export default {
  data() {
    return {
      accountInfo: {
        userInfo: {}
      },
      user: {
        email: "",
        // emailCaptcha: "",
        newPwd: "",
        oldPwd: "",
        repeatNewPass:""
      }
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      userRes.getUserInfo().then(res => {
        this.accountInfo = Object.assign(this.accountInfo, res);
        this.user.email = res.email
      });
    },
    resetPwd() {
      this.$refs.resetModel.open();
    },
    submitBtn() {
      this.$refs["resetForm"].validate(valid => {
        if (valid) {
          const { user } = this;
          userRes.updatePwd(user).then(res => {
              this.$refs.resetModel.close();
            this.$confirm("您已重置密码, 请重新登录?", "提示", {
              confirmButtonText: "前往登录",
              cancelButtonText: "",
              showCancelButton: false,
              type: "success"
            }).then(() => {
              this.$router.push("/login");
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.info_row {
  display: flex;
  padding: 16px 0;
  color: $font-color;
  border-bottom: 1px solid #f6f6f6;
  & > span:nth-of-type(1) {
    flex: 0 0 100px;
    color: #999;
  }
}
.block {
  & > h2 {
    padding-bottom: 20px;
    font-size: 20px;
    margin: 0;
    color: $font-color;
    font-weight: 500;
  }
}
.reset_pwd {
  float: right;
}
</style>
